<template>
<!--    TODO appointment-past -->
    <tr class="clickable-row">
        <td><a href="" @click.prevent.stop>{{getDataString(appointment.date)}}</a></td>
        <td><a href="" @click.prevent.stop>{{getHourString(appointment.date)}}</a></td>
        <td><a href="" @click.prevent.stop>{{appointment.rate_name}}</a></td>
        <td v-if="appointment.canceled"><a href="" @click.prevent.stop><span class="label label-danger">{{ $t('components.appointment.canceled') }}</span></a></td>
        <td v-else-if="appointment.start_date_in_past">
            <a v-if="appointment.no_show_clients.includes(selectedClientId)" href="" @click.prevent.stop><span class="label label-warning">{{ $t('components.appointment.no_show') }}</span></a>
            <a v-else href="" @click.prevent.stop><span class="label label-success">{{ $t('components.appointment.done') }}</span></a>
        </td>
        <td v-else>
            <a href="" @click.prevent.stop><span class="label label-default">{{ $t('components.appointment.to_do') }}</span></a>
        </td>
    </tr>
</template>

<script>
import {Utils} from "../../common/utils";

export default {
    name: "AppointmentRow",
    props: {
        appointment: {
            type: Object,
            require: true
        },
        selectedClientId: {
            type: Number,
            default: null
        }
    },
    methods: {
        getDataString(date) {
            return Utils.getShortDateStringFromISO(date)
        },
        getHourString(date){
            return Utils.getHourStringFromISO(date)
        },
    }
};
</script>
